import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IValidTransactionInquiryFilterFormMeta {
  acquiringBank: FormInputMeta;
  emitterBank: FormInputMeta;
  transactionCode: FormInputMeta;
  referenceNumber: FormInputMeta;
  carrierNumber: FormInputMeta;
  startTransactionDate: FormInputMeta;
  endTransactionDate: FormInputMeta;

  schema: any;
}

const validTransactionInquiryFilterFormMeta = {} as IValidTransactionInquiryFilterFormMeta;

validTransactionInquiryFilterFormMeta.acquiringBank = {
  name: "acquiringBank",
  type: "select",
  label: "Banque Acquéreur",
  placeholder: "",
  validation: yup.string().nullable(),
};

validTransactionInquiryFilterFormMeta.emitterBank = {
  name: "emitterBank",
  type: "select",
  label: "Banque Emetteur",
  placeholder: "",
  validation: yup.string().nullable(),
};

validTransactionInquiryFilterFormMeta.transactionCode = {
  name: "transactionCode",
  type: "text",
  label: "Code Transaction",
  placeholder: "",
  validation: yup.string().nullable(),
};

validTransactionInquiryFilterFormMeta.referenceNumber = {
  name: "referenceNumber",
  type: "text",
  label: "Numéro Référence",
  placeholder: "",
  validation: yup.string().nullable(),
};

validTransactionInquiryFilterFormMeta.carrierNumber = {
  name: "carrierNumber",
  type: "text",
  label: "Numéro Porteur",
  placeholder: "",
  validation: yup.string().nullable(),
};

validTransactionInquiryFilterFormMeta.startTransactionDate = {
  name: "startTransactionDate",
  type: "date",
  label: "Date Transaction Du",
  placeholder: "",
  // validation: yup.date().nullable(),
};

validTransactionInquiryFilterFormMeta.endTransactionDate = {
  name: "endTransactionDate",
  type: "date",
  label: "Au",
  placeholder: "",
  // validation: yup.date().nullable(),
};


validTransactionInquiryFilterFormMeta.schema = yup.object().shape(getValidationSchema(validTransactionInquiryFilterFormMeta));

export default validTransactionInquiryFilterFormMeta;